var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 25 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.63672 16c.55228 0 1 .4477 1 1v2c0 .2652.10534.5195.29291.7071h.00001c.18752.1875.44185.2929.70708.2929h11.99998c.2652 0 .5195-.1053.7071-.2929s.2929-.4419.2929-.7071v-2c0-.5523.4477-1 1-1s1 .4477 1 1v2c0 .7956-.316 1.5587-.8787 2.1213-.5626.5626-1.3257.8787-2.1213.8787h-11.99998c-.79563 0-1.55872-.316-2.12134-.8787-.56258-.5626-.87866-1.3257-.87866-2.1213v-2c0-.5523.44771-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.92961 10.2929c.39053-.39053 1.02369-.39053 1.41422 0l4.29287 4.2929 4.2929-4.2929c.3905-.39053 1.0237-.39053 1.4142 0 .3906.3905.3906 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0l-4.99999-5c-.39052-.3905-.39052-1.0237 0-1.4142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.6367 3c.5523 0 1 .44772 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-12c0-.55228.4477-1 1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.645b6db1a1a6529102f1b93a793392d1.svg";
export { ForwardRef as ReactComponent };